import { useSelector } from "react-redux";
import { mapsServiceIcon, mapsServiceUrl } from "../Utils";

export const FullAddress = ({ deliveryAddress }) => {
  // address, address2, postal, place

  const address = deliveryAddress?.address;
  const address2 = deliveryAddress?.address2;
  const postal = deliveryAddress?.postal;
  const place = deliveryAddress?.place;

  if (address2) {
    return `${address}, ${address2}, ${postal} ${place}`;
  } else {
    return `${address}, ${postal} ${place}`;
  }
};

export const MapsButton = ({ address = {}, location = "" }) => {
  const FULL_ADDRESS = FullAddress(address);
  const settings = useSelector((state) => state.session.currentUser.settings);

  return (
    <div className="relative right-0 text-right min-w-full items-center">
      <a
        href={mapsServiceUrl(
          location || FULL_ADDRESS,
          settings.preferred_maps_service
        )}
        rel="noreferrer"
        target="_blank"
        type="button"
        className="inline-flex items-center text-center min-w-full rounded-md border border-transparent bg-blue-500 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
      >
        {mapsServiceIcon(settings.preferred_maps_service)}
        <span className="ml-2 sr-only">Vis på kart</span>
      </a>
      {/* 
  <button
    onClick={() => setReportDialogOpen(true)}
    type="button"
    className="ml-2 inline-flex items-center rounded-md border border-transparent bg-blue-500 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
  >
    <PencilSquareIcon className="h-4 w-4" aria-hidden="true" />
  </button> */}
    </div>
  );
};
